module.exports = __webpack_public_path__ + "static/media/regisValidateOtp.e9bc9d51.svg";